export default "__VITE_PUBLIC_ASSET__5bbeec97__"